export const VIDEO_SHOW_RESET = 'VIDEO_SHOW_RESET';
export const VIDEO_SHOW_SET_ERROR = 'VIDEO_SHOW_SET_ERROR';
export const VIDEO_SHOW_SET_RETRIEVED = 'VIDEO_SHOW_SET_RETRIEVED';
export const VIDEO_SHOW_TOGGLE_LOADING = 'VIDEO_SHOW_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/video/show/mutation_types.js